<template lang="html">

 <nav class="pagination flex wrap row justify-between" v-if="numPost > 10">
  <a class="prev" :show="actual > 1" @click="prev"><i class="fa fa-angle-left" aria-hidden="true"></i>{{$t('genericos.paginador.anterior')}}</a>
  <ul class="flex row justify-center">
    <li v-for="(i,key) in paginas"><a :class="actual == i ? 'active' : ''" @click="goTo(i)">{{i}}</a></li>
  </ul>
  <a :show="actual < paginas" class="next" @click="next">{{$t('genericos.paginador.siguiente')}}<i class="fa fa-angle-right" aria-hidden="true"></i></a>
</nav>

</template>

<script lang="js">
  export default  {
    name: 'paginador',
    props: ['numPost'],
    mounted() {

    },
    data() {
      return {
        actual : 1
      }
    },
    methods: {  
      goTo: function(value){
        this.actual = value;
      },
      prev : function(){
        this.actual--;
      },
      next : function(){
        this.actual++;
      }
    },
    computed: {
      paginas  : function(){
        return Math.ceil(this.numPost / 10);
      }
    },
    watch : {
      'actual' : function(){
        this.$emit("change", this.actual);
      }
    }
  }
</script>

<style scoped>
.pagination > a{
  opacity: 0;
  pointer-events: none;
}

.pagination > a[show="true"]{
  opacity: 1;
  pointer-events: visible
}
</style>



// WEBPACK FOOTER //
// src/components/parts/paginador.vue